import React from 'react';

function Footer() {
  return (
    /* 1. 새로 만든 'footer-arc' 클래스를 추가합니다. */
    <footer className="w-full bg-white text-gray-600 border-t text-xs pt-2 pb-4">
  <div className="max-w-7xl mx-auto px-4">
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-y-2 text-left">

      {/* 왼쪽: 회사 정보 */}
      <div className="space-y-1">
        <div className="text-blue-500 font-bold text-sm">With-AI</div>
        <div className="text-xs leading-tight">
          상호명: Green Apple 이정현 <span className="mx-1">|</span> 사업자등록번호: 895-07-03078
        </div>
        <p className="text-xs leading-tight text-gray-400">
          © 2025 Green Apple. All rights reserved.
        </p>
      </div>

      {/* 오른쪽: 가로 정렬된 링크들 - 수직 중앙 정렬됨 */}
      <div className="flex flex-wrap gap-x-4 text-xs mt-1 md:mt-0">
        <a href="#" className="hover:text-blue-600">개인정보 처리 방침</a>
        <a href="#" className="hover:text-blue-600">이용약관</a>
        <a href="mailto:jyfree@changzakso.com" className="hover:text-blue-600">이메일 문의</a>
      </div>

    </div>
  </div>
</footer>
  );
}

export default Footer;